import React, { useState, useEffect } from "react";
import {
  Navbar,
  Nav,
  Container,
  Button,
  Offcanvas,
  Dropdown,
  Modal,
} from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import { GoBell } from "react-icons/go";
import { BsChevronDown } from "react-icons/bs";
import logoLight from "../assets/images/logo.png";
import logoDark from "../assets/images/logo-dark.png";
import user from "../assets/images/user.png";

import { useTheme } from "../context/ThemeContext";

const Header = () => {
  const navigate = useNavigate();
  const expand = "lg";
  const { isDarkMode, toggleTheme } = useTheme();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showOffcanvas, setShowOffcanvas] = useState(false); // State to manage Offcanvas visibility

  useEffect(() => {
    const loginStatus = localStorage.getItem("isLoggedIn");
    if (loginStatus === "true") {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  // Handle logout action
  const handleLogout = () => {
    localStorage.removeItem("isLoggedIn");
    setIsLoggedIn(false);
    setShowLogoutModal(false);
    navigate("/");
  };

  // Handle notifications click
  const handleNotificationsClick = () => {
    navigate("/notifications");
  };

  // Handle Offcanvas close
  const handleOffcanvasClose = () => {
    setShowOffcanvas(false); // Close the offcanvas menu
  };

  const handleNotificationsAndClose = () => {
    handleNotificationsClick(); // Navigate to /notifications
    handleOffcanvasClose(); // Close the Offcanvas menu
  };

  return (
    <>
      <Navbar expand={expand} className="dr-header">
        <Container>
          <Navbar.Brand as={NavLink} to="/" className="me-auto me-lg-0">
            <img
              src={isDarkMode ? logoDark : logoLight}
              alt="healthscope.ai"
              className="d-inline-block align-top"
            />
          </Navbar.Brand>

          {/* Right - Actions (desktop only) */}
          <div className="actions d-none d-lg-flex align-items-center gap-2 ms-auto">
            {/* Theme Toggle */}
            {/* <div className="toggle-container me-2">
              <input
                type="checkbox"
                className="toggle-switch"
                id="theme-toggle"
                checked={isDarkMode}
                onChange={toggleTheme}
              />
              <label className="slider" htmlFor="theme-toggle">
                <span className="sun-icon"></span>
                <span className="moon-icon"></span>
              </label>
            </div> */}

            <Button
              variant="outline-secondary"
              className="btn-bell"
              aria-label="Notifications"
              onClick={handleNotificationsClick}
            >
              <GoBell />
              <span className="notification-dot"></span>
            </Button>
            {isLoggedIn ? (
              <span className="with-login">
                <Dropdown align="end" className="profile-dropdown d-lg-flex">
                  <Dropdown.Toggle
                    variant="outline-secondary"
                    id="dropdown-profile"
                    className="profile-btn"
                  >
                    <img
                      src={user}
                      alt="Profile"
                      className="avatar-img"
                      width="34"
                      height="34"
                    />
                    Welcome, <span>John</span>{" "}
                    <BsChevronDown className="ms-2" />
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item as={NavLink} to="/profile">
                      Profile
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => setShowLogoutModal(true)}>
                      Logout
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </span>
            ) : (
              <span className="without-login">
                <Button
                  as={NavLink}
                  to="/login"
                  variant="outline-primary"
                  className="btn-pill"
                >
                  Login
                </Button>
                <Button
                  as={NavLink}
                  to="/register"
                  variant="outline-primary"
                  className="btn-pill"
                >
                  Sign up
                </Button>
              </span>
            )}
          </div>

          {/* Toggler (mobile only) */}
          <Navbar.Toggle
            aria-controls={`offcanvasNavbar-${expand}`}
            className="d-lg-none"
            onClick={() => setShowOffcanvas(true)} // Open the Offcanvas menu on click
          />

          {/* Offcanvas (mobile only) */}
          <Navbar.Offcanvas
            id={`offcanvasNavbar-${expand}`}
            aria-labelledby={`offcanvasNavbarLabel-${expand}`}
            placement="start"
            className="dr-offcanvas d-lg-none"
            show={showOffcanvas}
            onHide={handleOffcanvasClose} // Close the Offcanvas when it is hidden
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id={`offcanvasNavbarLabel-${expand}`}>
                <img
                  src={isDarkMode ? logoDark : logoLight}
                  alt="healthscope.ai"
                />
              </Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body>
              <Nav className="flex-column">
                <Nav.Link as={NavLink} to="/" onClick={handleOffcanvasClose}>
                  Home
                </Nav.Link>
                <Nav.Link
                  as={NavLink}
                  to="/explore"
                  onClick={handleOffcanvasClose}
                >
                  Explore
                </Nav.Link>
                <Nav.Link
                  as={NavLink}
                  to="/pricing"
                  onClick={handleOffcanvasClose}
                >
                  Pricing
                </Nav.Link>
                <Nav.Link
                  as={NavLink}
                  to="/community"
                  onClick={handleOffcanvasClose}
                >
                  Community
                </Nav.Link>
                <Nav.Link
                  as={NavLink}
                  to="/help"
                  onClick={handleOffcanvasClose}
                >
                  Help
                </Nav.Link>
              </Nav>

              <div className="offcanvas-actions">
                <Button
                  variant="outline-secondary"
                  className="btn-bell"
                  aria-label="Notifications"
                  onClick={handleNotificationsAndClose}
                >
                  <GoBell />
                  <span className="notification-dot"></span>
                </Button>
                {isLoggedIn ? (
                  <span className="with-login">
                    <Dropdown
                      align="end"
                      className="profile-dropdown d-lg-flex"
                    >
                      <Dropdown.Toggle
                        variant="outline-secondary"
                        id="dropdown-profile"
                        className="profile-btn"
                      >
                        <img
                          src={user}
                          alt="Profile"
                          className="avatar-img"
                          width="34"
                          height="34"
                        />
                        Welcome, <span>John</span>{" "}
                        <BsChevronDown className="ms-2" />
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item
                          as={NavLink}
                          to="/profile"
                          onClick={handleOffcanvasClose}
                        >
                          Profile
                        </Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item
                          as={NavLink}
                          to="/"
                          onClick={handleLogout}
                        >
                          Logout
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </span>
                ) : (
                  <span className="without-login">
                    <Button
                      as={NavLink}
                      to="/login"
                      variant="outline-primary"
                      className="btn-pill"
                      onClick={handleOffcanvasClose}
                    >
                      Login
                    </Button>
                    <Button
                      as={NavLink}
                      to="/register"
                      variant="outline-primary"
                      className="btn-pill"
                      onClick={handleOffcanvasClose}
                    >
                      Sign up
                    </Button>
                  </span>
                )}
              </div>
            </Offcanvas.Body>
          </Navbar.Offcanvas>

          {/* Center Nav (desktop only) */}
          <div className="nav-center d-none d-lg-flex">
            <Nav className="align-items-center">
              <Nav.Link as={NavLink} to="/" end>
                Home
              </Nav.Link>
              <Nav.Link as={NavLink} to="/explore">
                Explore
              </Nav.Link>
              <Nav.Link as={NavLink} to="/pricing">
                Pricing
              </Nav.Link>
              <Nav.Link as={NavLink} to="/community">
                Community
              </Nav.Link>
              <Nav.Link as={NavLink} to="/help">
                Help
              </Nav.Link>
            </Nav>
          </div>
        </Container>
      </Navbar>

      {/* Logout Confirmation Modal */}
      <Modal
        show={showLogoutModal}
        onHide={() => setShowLogoutModal(false)}
        centered
        size="sm"
      >
        <Modal.Header closeButton>
          <Modal.Title>Logout Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body closeButton>Are you sure you want to logout?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowLogoutModal(false)}>
            No
          </Button>
          <Button variant="danger" onClick={handleLogout}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Header;
